import { useQuery } from "@tanstack/react-query";
import { HardDrive } from "lucide-react";
import { Link } from "react-router-dom";

import { api, unwrap } from "@/lib/api";
import { useT } from "@/lib/i18n";
import { cn } from "@/lib/utils";

/** Super admin uchun: bepul ombor hajmi to'layotganini (80%+) har sahifada ko'rsatadi. Dastur to'xtamaydi. */
export function StorageBanner() {
  const { t } = useT();
  const q = useQuery({
    queryKey: ["object-storage"],
    queryFn: async () => unwrap(await api.GET("/api/hosting/object-storage/")),
    refetchInterval: 10 * 60_000,
    retry: false,
  });
  const s = q.data;
  if (!s || !s.configured || (s.level !== "yellow" && s.level !== "red")) return null;
  const red = s.level === "red";
  return (
    <Link
      to="/server"
      role="status"
      className={cn(
        "mb-4 flex items-center gap-3 rounded-lg border p-3 text-sm",
        red ? "border-danger/50 bg-danger/10" : "border-warning/50 bg-warning/10",
      )}
    >
      <HardDrive className="size-5 shrink-0" />
      <span>
        {red
          ? t("ostore.banner_full", {
              used: s.used_gb,
              free: s.free_gb,
              usd: s.estimated_monthly_usd,
            })
          : t("ostore.banner_warn", { pct: s.percent, used: s.used_gb, free: s.free_gb })}
      </span>
    </Link>
  );
}
